import { useEffect } from 'react';

import {
  adminRatingItems,
  getAdminPharmacistRating,
  getAdminRatingItems,
} from '@pharmaplan/common';

import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';

/*
  This hook returns properties only for full-service
*/
const useAdminViewRating = (_: any, pharmacistId: string) => {
  const dispatch = useAppDispatch();
  const ratingData = useAppSelector(adminRatingItems);

  useEffect(() => {
    dispatch(getAdminRatingItems());
    dispatch(getAdminPharmacistRating(pharmacistId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    idProperty: 'pharmacistRatingItemId',
    itemProperty: 'pharmacistRatingItems',
    ratingData,
  };
};
export default useAdminViewRating;
